import { jsonConvert } from '@/helpers/jsonConvert'
import { tiptapValueEmpty } from '@/helpers/new/tiptapValueEmpty'
import { FC, useMemo } from 'react'
import tiptap from "@/components/pages/Admin/Surveys/common.module.css";
import Tiptap from "@UI/Tiptap";
import classNames from 'classnames';
import cn from './index.module.css'

interface ITipTapView {
  className?: string
  value: string
}

const TipTapView: FC<ITipTapView> = ({ value, className }) => {
  const tiptapData = useMemo(() => jsonConvert(value), [value])

  if (tiptapValueEmpty(tiptapData)) {
    return <></>
  }

  return (
    <div className={classNames(cn.wrapper,className)}>
      <Tiptap
        value={tiptapData}
        //@ts-ignore
        setValue={() => {}}
        tiptapClassContent={classNames(
          tiptap.tiptapClassContent,
          cn.tiptapClassContentShow,
        )}
        tiptapClassContentProseMirror={tiptap.tiptapClassContentProseMirror}
        placeholder={``}
        disabled={true}
        error={undefined}
      />
    </div>
  )
}

export default TipTapView
